/**
 * Clipboard utility.
 *
 * Canonical implementation from packages/ssm-web5/src/utils/copy.js.
 * Uses the modern `navigator.clipboard` API (supported by all current browsers).
 *
 * NOTE: The toast callback that existed in ssm-web5's version is intentionally
 * removed here — toast is a UI concern and should be handled by the caller.
 */

/**
 * Copy text to the system clipboard.
 *
 * @param {string} text — the text to copy
 * @returns {Promise<void>}
 */
export function copyToClipboard(text) {
    return navigator.clipboard.writeText(text);
}
